// The Estimate tool's bootstrap (Estimate Tool 2.4): the company directory, the rating counts
// and their watermark, the measured project-to-client join, and the estimate settings.
//
// It is loaded when the reader first enters the Estimate tool rather than on page load, because
// the Forecast tool never reads it and most sessions never leave Forecast. Every component that
// needs it calls `loadEstimate()`; the call is idempotent, so the strip and the page asking at
// the same moment produce one request.

import { store } from './store.js';
import { api } from './api.js';

let inFlight = null;

/**
 * Load the bootstrap once. Pass `{ force: true }` after a write that changes it (Phase E3).
 * @returns {Promise<object|null>} the payload, or null when it could not be read
 */
export function loadEstimate({ force = false } = {}) {
  const { estimate } = store.get();
  if (!force && (estimate.ready || estimate.loading))
    return inFlight ?? Promise.resolve(estimate.data);

  store.setEstimate({ loading: true, error: null });
  inFlight = api
    .get('/estimate/bootstrap')
    .then((data) => {
      store.setEstimate({ ready: true, loading: false, error: null, data });
      return data;
    })
    .catch((err) => {
      store.setEstimate({
        ready: true,
        loading: false,
        error: `Could not load the estimate directory: ${err.message}`,
        data: null,
      });
      return null;
    })
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}
